import React from 'react';
import './CPreload.scss';

export const CPreload = () => {
	return <main className="preload-common"></main>;
};
